import gql from 'graphql-tag';

export const PRICE = gql`
    query Price($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            price {
                asOfDate
                navFiftyTwoWeekHigh
                navFiftyTwoWeekLow
                bidAskSpreadMonthlyMedian
                closingPriceFiftyTwoWeekHigh
                closingPriceFiftyTwoWeekLow
            }
        }
    }
`;
